import { Box, Typography, styled, Card } from "@mui/material";

const CardRoot = styled(Card, {
  shouldForwardProp: (prop) => prop !== "width" && prop !== "height",
})(({ theme }) => ({
  borderRadius: 12,
  padding: "20px 24px",
  display: "flex",
  flex: "1 1 220px",
  flexDirection: "column",
  alignItems: "flex-start",
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: "none",
  minHeight: 140,
}));

const CardLabel = styled(Typography)(() => ({
  fontSize: "0.875rem",
  fontWeight: 400,
}));

const CardValue = styled(Typography)(() => ({
  fontSize: "2rem",
  fontWeight: 700,
  lineHeight: 1.2,
}));

const Badge = styled(Box, {
  shouldForwardProp: (prop) => prop !== "direction",
})(({ theme, direction }) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: 4,
  padding: "2px 10px",
  borderRadius: "999px",
  fontSize: "0.8rem",
  fontWeight: 600,
  width: "fit-content",
  backgroundColor:
    direction === "up"
      ? "rgba(39, 174, 96, 0.2)"
      : direction === "down"
        ? "rgba(235, 87, 87, 0.2)"
        : "transparent",
  color:
    direction === "up"
      ? "#27AE60"
      : direction === "down"
        ? "#EB5757"
        : theme.palette.text.primary,
  border:
    direction === "up"
      ? "1px solid rgba(39,174,96,0.3)"
      : direction === "down"
        ? "1px solid rgba(235,87,87,0.3)"
        : `1px solid ${theme.palette.divider}`,
}));

const SubLabel = styled(Typography)(() => ({
  fontSize: "0.75rem",
}));

const KpiCard = ({
  label,
  value,
  badgeType,
  changePercent,
  changeDirection,
  changeLabel,
}) => {
  const renderBadge = () => {
    if (badgeType === "static_label") {
      return <Badge>{changeLabel}</Badge>;
    }

    if (badgeType === "percent_change" && changePercent != null) {
      const absValue = Math.abs(changePercent);
      const prefix = changeDirection === "up" ? "+" : "-";
      return (
        <Badge direction={changeDirection}>
          {prefix}
          {absValue}%
        </Badge>
      );
    }

    return null;
  };

  return (
    <CardRoot>
      <CardLabel>{label}</CardLabel>
      <CardValue>{value}</CardValue>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
        {renderBadge()}
        {badgeType === "percent_change" && changeLabel && (
          <SubLabel>{changeLabel}</SubLabel>
        )}
      </Box>
    </CardRoot>
  );
};

export default KpiCard;
